import { useEffect, useState } from "react";

const navItems = [
  { href: "#overview", label: "本站导览" },
  { href: "#styles", label: "画风图鉴" },
  { href: "#works", label: "作品合集" },
  { href: "#characters", label: "人物关系" },
  { href: "#guide", label: "阅读指南" },
  { href: "#community", label: "同人术语" },
  { href: "#faq", label: "常见问答" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
            女友的妈妈
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 rounded-md transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs font-medium whitespace-nowrap">
            <i className="ri-shield-check-line"></i>
            18+ 内容导览
          </span>
          <a
            href="#works"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            浏览合集
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className="lg:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-900 border border-background-300/70 bg-background-50/70"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/80 px-4 py-3">
          <nav className="grid grid-cols-2 gap-1.5">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-800 rounded-md bg-background-100 hover:bg-background-200 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#works"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium"
          >
            浏览作品合集
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      )}
    </header>
  );
}